import { instance } from "../axios"
import type { AxiosRequestConfig } from "axios"

// 取得 journeys
export function getJourneys(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/journeys/",
        method: "get",
        ...config,
    })
}

// 取得 journeys 類別
export function getJourneyStatus(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/journeys/status/",
        method: "get",
        ...config,
    })
}

// 取得 journeys 各類別數量
export function getJourneysStatusCount(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/journeys/counts/",
        method: "get",
        ...config,
    })
}

// 取得單個 journey
export function getJourney(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/${id}/`,
        method: "get",
        ...config,
    })
}

// 新增 journey
export function createJourney(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: "/journeys/",
        method: "post",
        ...config,
    })
}

// 複製 journey
export function copyJourney(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/${id}/copy/`,
        method: "post",
        ...config,
    })
}

// 編輯 journey
export function updateJourney(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/${id}/`,
        method: "put",
        ...config,
    })
}

// 部分更新 journey
export function patchJourney(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/${id}/`,
        method: "patch",
        ...config,
    })
}

// 刪除 journey
export function deleteJourney(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/${id}/`,
        method: "delete",
        ...config,
    })
}

// 送審 journey
export function submitJourney(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/${id}/submit/`,
        method: "post",
        ...config,
    })
}

// 審核 journey
export function reviewJourney(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/${id}/review/`,
        method: "post",
        ...config,
    })
}

// 取得 journeys 審核人員
export function getJourneysReviewers(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/journeys/${uuid}/reviewers/`,
        method: "get",
        ...config,
    })
}

// 取消排程 journey
export function cancelJourney(id: string, config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/${id}/terminate/`,
        method: "post",
        ...config,
    })
}

// 取得劇本成效
export function getJourneyEffective(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/journeys/${uuid}/analytics/performance/`,
        method: "get",
        ...config,
    })
}

// 取得劇本成效名單
export function getJourneyEffectiveUserList(
    uuid: string,
    nodeShortId: string,
    port: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/journeys/${uuid}/nodes/${nodeShortId}/logs/${port}/`,
        method: "get",
        ...config,
    })
}

// 匯出劇本成效名單
export function exportJourneyEffectiveUserList(
    uuid: string,
    nodeShortId: string,
    port: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/journeys/${uuid}/nodes/${nodeShortId}/logs/${port}/export/`,
        method: "post",
        ...config,
    })
}

// 取得劇本排序
export function getJourneyPriority(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/priority/`,
        method: "get",
        ...config,
    })
}

// 批次更新劇本排序
export function updateJourneyPriority(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/priority/`,
        method: "post",
        ...config,
    })
}

// 取得劇本劇本分析大部分資訊
export function getJourneyAnalytics(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/journeys/${uuid}/analytics/`,
        method: "get",
        ...config,
    })
}

// 取得劇本劇本群組參與分析
export function getJourneyAnalyticsCohort(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/journeys/${uuid}/analytics/cohort/`,
        method: "get",
        ...config,
    })
}

// 取得劇本有效母數節點列表
export function getJourneySourceNode(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/journeys/${uuid}/source-node/`,
        method: "get",
        ...config,
    })
}
// 取得母數節點商品分類
export function getJourneyItemList(config: AxiosRequestConfig = {}) {
    return instance.request({
        url: `/journeys/item-list/`,
        method: "get",
        ...config,
    })
}

// 匯出劇本分析結果
export function exportJourneyAnalytics(
    uuid: string,
    config: AxiosRequestConfig = {}
) {
    return instance.request({
        url: `/journeys/${uuid}/analytics/export/`,
        method: "post",
        ...config,
    })
}
